import { render, staticRenderFns } from "./GP2BrowserResearchModal.vue?vue&type=template&id=22f7dfda&scoped=true&"
import script from "./GP2BrowserResearchModal.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserResearchModal.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserResearchModal.vue?vue&type=style&index=0&id=22f7dfda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7dfda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f7dfda')) {
      api.createRecord('22f7dfda', component.options)
    } else {
      api.reload('22f7dfda', component.options)
    }
    module.hot.accept("./GP2BrowserResearchModal.vue?vue&type=template&id=22f7dfda&scoped=true&", function () {
      api.rerender('22f7dfda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserResearchModal.vue"
export default component.exports